
interface IProps {
  color?: string;

}

export const TwitchFilled = ({color="#010201"}: IProps) => {
  return (
    <svg width="77" height="77" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.5 61C50.9264 61 61 50.9264 61 38.5C61 26.0736 50.9264 16 38.5 16C26.0736 16 16 26.0736 16 38.5C16 50.9264 26.0736 61 38.5 61Z" fill={color}/>
      <path d="M30.7227 24.6099L25.166 30.1665V50.1665H31.8327V55.7232L37.3893 50.1665H41.8327L51.8327 40.1665V24.6099H30.7227ZM49.6127 39.0532L45.1693 43.4965H40.726L36.836 47.3865V43.4965H31.836V26.8332H49.6127V39.0565V39.0532Z" fill="white"/>
      <path d="M46.278 30.7231H44.0547V37.3898H46.278V30.7231Z" fill="white"/>
      <path d="M40.1667 30.7231H37.9434V37.3898H40.1667V30.7231Z" fill="white"/>
    </svg> 
  )
}